import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ToggleButtonComponent } from './toggle-button/toggle-button.component';
import { FormsModule } from '@angular/forms';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { GlobalLottieLoaderComponent } from './global-lottie-loader/global-lottie-loader.component';
import { LottieModule } from 'ngx-lottie';
import player from "lottie-web";

export function playerFactory() {
  return player;
}


@NgModule({
  declarations: [
    ToggleButtonComponent,
    GlobalLottieLoaderComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    MatCardModule,
    MatFormFieldModule,
    MatInputModule,

    LottieModule.forRoot({ player: playerFactory })
  ],
  exports:[
    ToggleButtonComponent,
    GlobalLottieLoaderComponent
  ]
})
export class CommonComponentModule { }
